import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';

export default () => {
  return (
    <div className="swiperContainer">
      <Swiper 
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        slidesPerView={1}
        navigation
        effect={'fade'}
        speed={800}
        loop
        autoplay
        className="swiper"
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        // onSwiper={(swiper) => console.log(swiper)}
        // onSlideChange={() => console.log('slide change')}
      >
        <SwiperSlide className="swiperSlide"><img src="./img/img1.jpg" /></SwiperSlide>
        <SwiperSlide className="swiperSlide"><img src="./img/img2.jpg" /></SwiperSlide>
        <SwiperSlide className="swiperSlide"><img src="./img/img3.jpg" /></SwiperSlide>
        <SwiperSlide className="swiperSlide"><img src="./img/img4.jpg" /></SwiperSlide>
        <SwiperSlide className="swiperSlide"><img src="./img/img5.jpg" /></SwiperSlide>
      </Swiper>
    </div>
  );
};